var map = {
	".": 72812,
	"./": 72812,
	"./App": 54111,
	"./App.css": 44050,
	"./App.js": 54111,
	"./amplifyconfiguration": 19723,
	"./amplifyconfiguration.json": 19723,
	"./assets/db/users": 60831,
	"./assets/db/users.js": 60831,
	"./assets/icons/bell.png": 50450,
	"./assets/icons/logo.png": 76928,
	"./assets/icons/profile.png": 68658,
	"./assets/img/black-logo.png": 32679,
	"./assets/img/logo-sportmadness-large.png": 42527,
	"./assets/img/logo-sportmadness.png": 71597,
	"./assets/img/white-logo-lg.png": 16395,
	"./assets/languages/i18n/en": 76046,
	"./assets/languages/i18n/en.js": 76046,
	"./assets/languages/i18n/es": 50041,
	"./assets/languages/i18n/es.js": 50041,
	"./assets/languages/i18n/fr": 8529,
	"./assets/languages/i18n/fr.js": 8529,
	"./assets/languages/icons/english.png": 38153,
	"./assets/languages/icons/france.png": 23816,
	"./assets/languages/icons/icon-france.png": 16532,
	"./assets/languages/icons/icon-spain.png": 61278,
	"./assets/languages/icons/icon-usa.png": 8536,
	"./assets/languages/icons/spain.png": 61706,
	"./assets/languages/languages": 20307,
	"./assets/languages/languages.js": 20307,
	"./aws-exports": 73535,
	"./aws-exports.js": 73535,
	"./components/Content/Content": 60670,
	"./components/Content/Content.js": 60670,
	"./components/Home": 5210,
	"./components/Home.js": 5210,
	"./components/TopBar/TopBar": 57885,
	"./components/TopBar/TopBar.js": 57885,
	"./components/UI/Logo/Logo": 1775,
	"./components/UI/Logo/Logo.css": 56734,
	"./components/UI/Logo/Logo.js": 1775,
	"./config": 93488,
	"./config.js": 93488,
	"./containers/Academy/Courses/List": 35938,
	"./containers/Academy/Courses/List/": 35938,
	"./containers/Academy/Courses/List/index": 35938,
	"./containers/Academy/Courses/List/index.js": 35938,
	"./containers/Academy/Courses/Preview": 93802,
	"./containers/Academy/Courses/Preview/": 93802,
	"./containers/Academy/Courses/Preview/index": 93802,
	"./containers/Academy/Courses/Preview/index.js": 93802,
	"./containers/Academy/Courses/Single": 21734,
	"./containers/Academy/Courses/Single/": 21734,
	"./containers/Academy/Courses/Single/index": 21734,
	"./containers/Academy/Courses/Single/index.js": 21734,
	"./containers/Billing/List": 26930,
	"./containers/Billing/List/": 26930,
	"./containers/Billing/List/index": 26930,
	"./containers/Billing/List/index.js": 26930,
	"./containers/Billing/Office/List": 14019,
	"./containers/Billing/Office/List/": 14019,
	"./containers/Billing/Office/List/index": 14019,
	"./containers/Billing/Office/List/index.js": 14019,
	"./containers/Billing/Settings": 38467,
	"./containers/Billing/Settings/": 38467,
	"./containers/Billing/Settings/index": 38467,
	"./containers/Billing/Settings/index.js": 38467,
	"./containers/Billing/Single": 42230,
	"./containers/Billing/Single/": 42230,
	"./containers/Billing/Single/index": 42230,
	"./containers/Billing/Single/index.js": 42230,
	"./containers/Billing/Subscriptions/List": 3373,
	"./containers/Billing/Subscriptions/List/": 3373,
	"./containers/Billing/Subscriptions/List/index": 3373,
	"./containers/Billing/Subscriptions/List/index.js": 3373,
	"./containers/Billing/Subscriptions/Single": 84741,
	"./containers/Billing/Subscriptions/Single/": 84741,
	"./containers/Billing/Subscriptions/Single/index": 84741,
	"./containers/Billing/Subscriptions/Single/index.js": 84741,
	"./containers/Franchises/FranchisesOld": 38067,
	"./containers/Franchises/FranchisesOld.js": 38067,
	"./containers/Franchises/List": 65567,
	"./containers/Franchises/List/": 65567,
	"./containers/Franchises/List/index": 65567,
	"./containers/Franchises/List/index.js": 65567,
	"./containers/Franchises/Opportunity": 15764,
	"./containers/Franchises/Opportunity/": 15764,
	"./containers/Franchises/Opportunity/index": 15764,
	"./containers/Franchises/Opportunity/index.js": 15764,
	"./containers/Franchises/Project": 93616,
	"./containers/Franchises/Project/": 93616,
	"./containers/Franchises/Project/index": 93616,
	"./containers/Franchises/Project/index.js": 93616,
	"./containers/Franchises/Single": 42207,
	"./containers/Franchises/Single/": 42207,
	"./containers/Franchises/Single/index": 42207,
	"./containers/Franchises/Single/index.js": 42207,
	"./containers/Login/Login": 50170,
	"./containers/Login/Login.js": 50170,
	"./containers/ResetPassword": 42647,
	"./containers/ResetPassword/": 42647,
	"./containers/ResetPassword/index": 42647,
	"./containers/ResetPassword/index.js": 42647,
	"./containers/Template": 29768,
	"./containers/Template/": 29768,
	"./containers/Template/Template": 97688,
	"./containers/Template/Template.js": 97688,
	"./containers/Template/index": 29768,
	"./containers/Template/index.js": 29768,
	"./containers/Templates": 76361,
	"./containers/Templates/": 76361,
	"./containers/Templates/index": 76361,
	"./containers/Templates/index.js": 76361,
	"./containers/Users/Users": 442,
	"./containers/Users/Users.js": 442,
	"./core/MUITheme": 50926,
	"./core/MUITheme.js": 50926,
	"./core/axios": 29044,
	"./core/axios.js": 29044,
	"./hoc/Auxiliary/Auxiliary": 28070,
	"./hoc/Auxiliary/Auxiliary.js": 28070,
	"./index": 72812,
	"./index.css": 59555,
	"./index.js": 72812,
	"./providers/UserProvider": 51371,
	"./providers/UserProvider.js": 51371,
	"./serviceWorker": 47001,
	"./serviceWorker.js": 47001,
	"./services/central-academy/academy.services": 63222,
	"./services/central-academy/academy.services.js": 63222,
	"./services/central-billing/invoices.services": 69491,
	"./services/central-billing/invoices.services.js": 69491,
	"./services/central-billing/office.services": 25999,
	"./services/central-billing/office.services.js": 25999,
	"./services/central-billing/settings.services": 92320,
	"./services/central-billing/settings.services.js": 92320,
	"./services/central-billing/subscriptions.services": 19209,
	"./services/central-billing/subscriptions.services.js": 19209,
	"./services/central-templates/templates.services": 89926,
	"./services/central-templates/templates.services.js": 89926,
	"./services/franchise-billing/invoices.services": 50549,
	"./services/franchise-billing/invoices.services.js": 50549,
	"./services/franchise-crm/contacts.services": 24165,
	"./services/franchise-crm/contacts.services.js": 24165,
	"./services/franchise-crm/opportunities.services": 25423,
	"./services/franchise-crm/opportunities.services.js": 25423,
	"./services/franchise-projects/projects.services": 48778,
	"./services/franchise-projects/projects.services.js": 48778,
	"./services/franchises.services": 6683,
	"./services/franchises.services.js": 6683,
	"./services/templates.services": 56194,
	"./services/templates.services.js": 56194,
	"./services/users.services": 28563,
	"./services/users.services.js": 28563,
	"./utils/currency": 20475,
	"./utils/currency.js": 20475,
	"./utils/dashboard": 76314,
	"./utils/dashboard.js": 76314,
	"./utils/franchises": 52716,
	"./utils/franchises.js": 52716,
	"App": 54111,
	"App.css": 44050,
	"App.js": 54111,
	"amplifyconfiguration": 19723,
	"amplifyconfiguration.json": 19723,
	"assets/db/users": 60831,
	"assets/db/users.js": 60831,
	"assets/icons/bell.png": 50450,
	"assets/icons/logo.png": 76928,
	"assets/icons/profile.png": 68658,
	"assets/img/black-logo.png": 32679,
	"assets/img/logo-sportmadness-large.png": 42527,
	"assets/img/logo-sportmadness.png": 71597,
	"assets/img/white-logo-lg.png": 16395,
	"assets/languages/i18n/en": 76046,
	"assets/languages/i18n/en.js": 76046,
	"assets/languages/i18n/es": 50041,
	"assets/languages/i18n/es.js": 50041,
	"assets/languages/i18n/fr": 8529,
	"assets/languages/i18n/fr.js": 8529,
	"assets/languages/icons/english.png": 38153,
	"assets/languages/icons/france.png": 23816,
	"assets/languages/icons/icon-france.png": 16532,
	"assets/languages/icons/icon-spain.png": 61278,
	"assets/languages/icons/icon-usa.png": 8536,
	"assets/languages/icons/spain.png": 61706,
	"assets/languages/languages": 20307,
	"assets/languages/languages.js": 20307,
	"aws-exports": 73535,
	"aws-exports.js": 73535,
	"components/Content/Content": 60670,
	"components/Content/Content.js": 60670,
	"components/Home": 5210,
	"components/Home.js": 5210,
	"components/TopBar/TopBar": 57885,
	"components/TopBar/TopBar.js": 57885,
	"components/UI/Logo/Logo": 1775,
	"components/UI/Logo/Logo.css": 56734,
	"components/UI/Logo/Logo.js": 1775,
	"config": 93488,
	"config.js": 93488,
	"containers/Academy/Courses/List": 35938,
	"containers/Academy/Courses/List/": 35938,
	"containers/Academy/Courses/List/index": 35938,
	"containers/Academy/Courses/List/index.js": 35938,
	"containers/Academy/Courses/Preview": 93802,
	"containers/Academy/Courses/Preview/": 93802,
	"containers/Academy/Courses/Preview/index": 93802,
	"containers/Academy/Courses/Preview/index.js": 93802,
	"containers/Academy/Courses/Single": 21734,
	"containers/Academy/Courses/Single/": 21734,
	"containers/Academy/Courses/Single/index": 21734,
	"containers/Academy/Courses/Single/index.js": 21734,
	"containers/Billing/List": 26930,
	"containers/Billing/List/": 26930,
	"containers/Billing/List/index": 26930,
	"containers/Billing/List/index.js": 26930,
	"containers/Billing/Office/List": 14019,
	"containers/Billing/Office/List/": 14019,
	"containers/Billing/Office/List/index": 14019,
	"containers/Billing/Office/List/index.js": 14019,
	"containers/Billing/Settings": 38467,
	"containers/Billing/Settings/": 38467,
	"containers/Billing/Settings/index": 38467,
	"containers/Billing/Settings/index.js": 38467,
	"containers/Billing/Single": 42230,
	"containers/Billing/Single/": 42230,
	"containers/Billing/Single/index": 42230,
	"containers/Billing/Single/index.js": 42230,
	"containers/Billing/Subscriptions/List": 3373,
	"containers/Billing/Subscriptions/List/": 3373,
	"containers/Billing/Subscriptions/List/index": 3373,
	"containers/Billing/Subscriptions/List/index.js": 3373,
	"containers/Billing/Subscriptions/Single": 84741,
	"containers/Billing/Subscriptions/Single/": 84741,
	"containers/Billing/Subscriptions/Single/index": 84741,
	"containers/Billing/Subscriptions/Single/index.js": 84741,
	"containers/Franchises/FranchisesOld": 38067,
	"containers/Franchises/FranchisesOld.js": 38067,
	"containers/Franchises/List": 65567,
	"containers/Franchises/List/": 65567,
	"containers/Franchises/List/index": 65567,
	"containers/Franchises/List/index.js": 65567,
	"containers/Franchises/Opportunity": 15764,
	"containers/Franchises/Opportunity/": 15764,
	"containers/Franchises/Opportunity/index": 15764,
	"containers/Franchises/Opportunity/index.js": 15764,
	"containers/Franchises/Project": 93616,
	"containers/Franchises/Project/": 93616,
	"containers/Franchises/Project/index": 93616,
	"containers/Franchises/Project/index.js": 93616,
	"containers/Franchises/Single": 42207,
	"containers/Franchises/Single/": 42207,
	"containers/Franchises/Single/index": 42207,
	"containers/Franchises/Single/index.js": 42207,
	"containers/Login/Login": 50170,
	"containers/Login/Login.js": 50170,
	"containers/ResetPassword": 42647,
	"containers/ResetPassword/": 42647,
	"containers/ResetPassword/index": 42647,
	"containers/ResetPassword/index.js": 42647,
	"containers/Template": 29768,
	"containers/Template/": 29768,
	"containers/Template/Template": 97688,
	"containers/Template/Template.js": 97688,
	"containers/Template/index": 29768,
	"containers/Template/index.js": 29768,
	"containers/Templates": 76361,
	"containers/Templates/": 76361,
	"containers/Templates/index": 76361,
	"containers/Templates/index.js": 76361,
	"containers/Users/Users": 442,
	"containers/Users/Users.js": 442,
	"core/MUITheme": 50926,
	"core/MUITheme.js": 50926,
	"core/axios": 29044,
	"core/axios.js": 29044,
	"hoc/Auxiliary/Auxiliary": 28070,
	"hoc/Auxiliary/Auxiliary.js": 28070,
	"index": 72812,
	"index.css": 59555,
	"index.js": 72812,
	"providers/UserProvider": 51371,
	"providers/UserProvider.js": 51371,
	"serviceWorker": 47001,
	"serviceWorker.js": 47001,
	"services/central-academy/academy.services": 63222,
	"services/central-academy/academy.services.js": 63222,
	"services/central-billing/invoices.services": 69491,
	"services/central-billing/invoices.services.js": 69491,
	"services/central-billing/office.services": 25999,
	"services/central-billing/office.services.js": 25999,
	"services/central-billing/settings.services": 92320,
	"services/central-billing/settings.services.js": 92320,
	"services/central-billing/subscriptions.services": 19209,
	"services/central-billing/subscriptions.services.js": 19209,
	"services/central-templates/templates.services": 89926,
	"services/central-templates/templates.services.js": 89926,
	"services/franchise-billing/invoices.services": 50549,
	"services/franchise-billing/invoices.services.js": 50549,
	"services/franchise-crm/contacts.services": 24165,
	"services/franchise-crm/contacts.services.js": 24165,
	"services/franchise-crm/opportunities.services": 25423,
	"services/franchise-crm/opportunities.services.js": 25423,
	"services/franchise-projects/projects.services": 48778,
	"services/franchise-projects/projects.services.js": 48778,
	"services/franchises.services": 6683,
	"services/franchises.services.js": 6683,
	"services/templates.services": 56194,
	"services/templates.services.js": 56194,
	"services/users.services": 28563,
	"services/users.services.js": 28563,
	"utils/currency": 20475,
	"utils/currency.js": 20475,
	"utils/dashboard": 76314,
	"utils/dashboard.js": 76314,
	"utils/franchises": 52716,
	"utils/franchises.js": 52716
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81407;